import { Phone, MessageCircle, Clock, Ruler, MapPin } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { QuoteForm } from "../components/QuoteForm";
import { PHONE_TEL, PHONE_DISPLAY, waLink } from "../lib/contact";

export default function Contact() {
  return (
    <main data-testid="contact-page">
      <section className="grain-overlay wood-ring bg-anthracite pb-20 pt-36 text-cream lg:pb-28 lg:pt-44">
        <div className="relative z-[2] mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-oak">Contact & solicitare ofertă</p>
            <h1 className="mt-5 max-w-3xl font-serif text-4xl font-black leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
              Spune-ne ce vrei să construim <em className="italic text-oak">împreună</em>
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-walnut">Sună-ne direct</p>
              <a
                href={PHONE_TEL}
                data-testid="contact-phone-big"
                className="mt-4 block font-serif text-5xl font-black tracking-tight text-ink transition-colors duration-300 hover:text-walnut sm:text-6xl"
              >
                {PHONE_DISPLAY}
              </a>
              <p className="mt-6 max-w-md text-sm leading-relaxed text-clay sm:text-base">
                Trimite-ne dimensiunile aproximative sau o poză pe WhatsApp pentru o
                cotație de preț rapidă. De regulă răspundem în aceeași zi.
              </p>

              <div className="mt-8 flex flex-col gap-4 sm:flex-row">
                <a
                  href={PHONE_TEL}
                  data-testid="contact-call-button"
                  className="flex h-13 items-center justify-center gap-3 rounded-full bg-anthracite px-7 py-4 text-xs font-bold uppercase tracking-[0.15em] text-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-walnut"
                >
                  <Phone size={16} /> Sună acum
                </a>
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-whatsapp-button"
                  className="flex items-center justify-center gap-3 rounded-full bg-[#25D366] px-7 py-4 text-xs font-bold uppercase tracking-[0.15em] text-anthracite transition-all duration-300 hover:-translate-y-0.5"
                >
                  <MessageCircle size={16} /> WhatsApp direct
                </a>
              </div>

              <ul className="mt-12 space-y-5 border-t border-line pt-8">
                <li className="flex items-start gap-4">
                  <MapPin size={19} className="mt-0.5 shrink-0 text-oak" />
                  <div>
                    <p className="font-semibold text-ink">Atelier LOGITEH PROD</p>
                    <p className="text-sm text-clay">
                      Brașov, str. Carierei nr. 127 · Responsabil execuție: Balcangiu Gabriel
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <Clock size={19} className="mt-0.5 shrink-0 text-oak" />
                  <div>
                    <p className="font-semibold text-ink">Program de lucru</p>
                    <p className="text-sm text-clay">Luni – Sâmbătă, 08:00 – 18:00</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <Ruler size={19} className="mt-0.5 shrink-0 text-oak" />
                  <div>
                    <p className="font-semibold text-ink">Măsurători la locație</p>
                    <p className="text-sm text-clay">
                      Ne deplasăm pentru măsurători și consultanță înainte de fiecare proiect.
                    </p>
                  </div>
                </li>
              </ul>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <div className="relative">
                <span className="absolute -left-3 -top-3 hidden h-full w-full border border-oak/50 lg:block" aria-hidden="true" />
                <div className="relative border border-line bg-white p-7 shadow-[0_24px_60px_-24px_rgba(24,21,18,0.18)] sm:p-10">
                  <h2 className="font-serif text-2xl font-bold text-ink sm:text-3xl">
                    Cere o ofertă de preț
                  </h2>
                  <p className="mt-2 text-sm text-clay">
                    Completezi în 30 de secunde, iar noi te sunăm înapoi cu detalii.
                  </p>
                  <div className="mt-8">
                    <QuoteForm />
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
}
